import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './utils/css/Toast.css'
import './utils/css/Div.css'


import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import MainProviders from './components/app/MainProviders';


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
        <MainProviders>
            <App/>
        </MainProviders>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
